import { FC } from 'react';
import { format, parseISO, startOfDay, endOfDay } from 'date-fns';
import { PricingRuleSheet } from './PricingRuleSheet';
import { PricingRule, PricingRuleFormData } from '@libs/schemas';
import { usePricingRules } from 'src/hooks/usePricingRules';

interface EditRuleSheetProps {
  rule: PricingRule;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

// Convert PricingRule to PricingRuleFormData for form usage
const ruleToFormData = (rule: PricingRule): PricingRuleFormData => {
  return {
    ...rule,
    // Convert datetime strings to date strings for HTML input (YYYY-MM-DD)
    effectiveFrom: rule.effectiveFrom ? format(parseISO(rule.effectiveFrom), 'yyyy-MM-dd') : '',
    effectiveTo: rule.effectiveTo ? format(parseISO(rule.effectiveTo), 'yyyy-MM-dd') : '',
  };
};

export const EditRuleSheet: FC<EditRuleSheetProps> = ({ rule, open, onOpenChange }) => {
  const { updateRule } = usePricingRules();

  const initialData = rule ? ruleToFormData(rule) : undefined;
  const handleSubmit = (updatedRule: PricingRuleFormData) => {
    // Convert form data back to PricingRule format
    // Convert date strings to ISO datetime strings using date-fns
    const transformedRule: PricingRule = {
      ...updatedRule,
      // Use date-fns to properly handle timezone and create ISO strings
      effectiveFrom: updatedRule.effectiveFrom
        ? startOfDay(parseISO(updatedRule.effectiveFrom)).toISOString()
        : '',
      effectiveTo: updatedRule.effectiveTo
        ? endOfDay(parseISO(updatedRule.effectiveTo)).toISOString()
        : '',
      // Preserve original timestamps
    };

    updateRule(transformedRule);
  };

  return (
    <PricingRuleSheet
      open={open}
      onOpenChange={onOpenChange}
      initialData={initialData}
      onSubmit={handleSubmit}
    />
  );
};
